/* eslint-disable react/jsx-no-target-blank */
import * as React from "react";
import ILegacyFooterProps from "./IProps";
import "../../../assets/sass/components/legacyFooter.scss";
import * as URL from "../../../config.json";
import IdleTimeout from "../IdleTimeout";

/**
 * @category Main Component
 * @description this component renders Popup while user trying to navigate aways from the dynamic form , so that user will be aware that the enter values will be lost if the user is navigating away from the form
 */
const LegacyFooter: React.SFC<ILegacyFooterProps> = (props) => {
    const termsOfSevice = `${URL["CONFIG"].footerUrl.termsOfSevice}`;
    const privacyPolicy = `${URL["CONFIG"].footerUrl.privacyPolicy}`;
    return (
        <React.Fragment>
            <IdleTimeout />
            <div id="legacy-footer-container" className="legacy-footer-container">
                <div className="d-flex">
                    <div className="copyright">&copy; Copyright 2020 GAF.&nbsp;All Rights Reserved.</div>
                    <div className="ml-auto">
                        <div className="terms-of-service">
                            <a href={termsOfSevice} target="_blank">
                                Terms of Service
                            </a>
                            <span>|</span>
                            <a href={privacyPolicy} target="_blank">
                                Privacy Policy
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
export default LegacyFooter;
